/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useContext, useLayoutEffect } from "react";
import { BrujoContext } from "../Context/BrujoContext";

export const SelectionSearch = ({label, name, value, onInputChange, array}) => {
  const { loadPeriodos,
    loadTipoObjeto,
    loadProveniencias,
    loadMateriales,
    loadCulturas } = useContext(BrujoContext);

  useLayoutEffect(() => {
    if (name === "periodo_id") {loadPeriodos();}
    if (name === "tipo_objeto_id") {loadTipoObjeto();}
    if (name === "proveniencia_codigo") {loadProveniencias();}
    if (name === "tipo_material_id") {loadMateriales();}
    if (name === "filiacion_cultural_id") {loadCulturas();}
  },[] );

  return (
    <>
      <label htmlFor={name}>
        {label}
      </label>
      <select name={name} id={name} value={value} onChange={onInputChange}>
        <option defaultValue="">Seleccionar</option>
        {
          array.map((item, index) => {
            if (name === "filiacion_cultural_id") {
              return(
                <option key={index} value={item.cul_id}>{ item.cul_name }</option>
              )
            }

            if (name === "tipo_material_id") {
              return(
                <option key={index} value={item.mat_id}>{ item.mat_name }</option>
              )
            }

            if (name === "periodo_id") {
              return(
                <option key={index} value={item.per_id}>{ item.per_name }</option>
              )
            }

            if (name === "tipo_objeto_id") {
              return(
                <option key={index} value={item.tob_id}>{ item.tob_name }</option>
              )
            }

            if (name === "proveniencia_codigo") {
              return(
                <option key={index} value={item.provenienciaCodigo}>{ item.provenienciaNombre }</option>
              )
            }
          })
        }
      </select>
    </>
  )
}
